import React from 'react';
import Header from '../Header/Header';
import MidiInputSelector from '../MidiInputSelector/MidiInputSelector';
import PianoKeyboard from '../PianoKeyboard/PianoKeyboard';
import ChordQueue from '../ChordQueue/ChordQueue';
import StatusBar from '../StatusBar/StatusBar';
import { useSettings } from '../../contexts/SettingsContext';


const PracticePage: React.FC = () => {
  const { isDarkMode } = useSettings();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <Header />
      
      <main className="container mx-auto px-4 py-4 max-w-5xl">
        <div className={`mb-6 p-4 ${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-lg`}>
          <MidiInputSelector />
        </div>

        <StatusBar />

        <div className="flex flex-col items-center">
          <ChordQueue />
        </div>

        <PianoKeyboard />
      </main>
    </div>
  );
};

export default PracticePage;
